import React from 'react';

import classNames from 'classnames';

import { TFolderId } from '@widgets/Files/model/types/folderId.type';

import cls from './AddFilesButton.module.css';
import { FileInput } from '../UI/FileInput/FileInput';

interface IAddFilesButtonProps {
    onFileChange: (files: File[], currentFolderId: TFolderId) => void;
}

export const AddFilesButton = ({ onFileChange }: IAddFilesButtonProps) => (
    <FileInput onChange={onFileChange} />
);
